// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__7q7gD","label":"LabeledBox_label__f7OBz"};